import api from "./api";

const getFacility = (id) => {
  return api.get("facilities/" + id);
};

const getFacilities = () => {
  return api.get("facilities").then((response) => {
    const { data } = response;
    return data;
  });
};

const addFacility = (facilityData) => {
  return api.post("facilities", facilityData).then((response) => {
    const { data: facilty } = response.data;
    return facilty;
  });
};

const editFacility = (facility_id, facilityData) => {
  return api.put(`facilities/${facility_id}`, facilityData).then((response) => {
    const { data: facilty } = response.data;
    return facilty;
  });
};

const getUserFacilities = (userId) => {
  return api.get(`users/${userId}/facilities`);
};

const deleteFacility = (id) => {
  return api.delete("facilities/" + id);
};
export default {
  getFacility,
  getFacilities,
  getUserFacilities,
  addFacility,
  editFacility,
  deleteFacility,
};
